import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import { TranslateResult } from "vue-i18n"

import InfiniteScrollSelect from "@/components/Common/InfiniteScrollSelect/index.vue"
import i18n from "@/i18n"
import { fetchAttributeValues } from "@/modules/offers/api/productModeration"
import type { AttributeValueSelectHandle } from "@/modules/offers/types/createOffer"
import {
  ProductModerationAttribute,
  ProductModerationAttributeValue
} from "@/modules/offers/types/offers"

import { getAttributeLabel, getAttributeValueLabel } from "../../utils/attributeLabels"
import { hasAttributeValue } from "../../utils/productAttributes"

import CreateAttributeValueModal from "./CreateAttributeValueModal.vue"

type Props = {
  attribute: ProductModerationAttribute
  showDeleteButton?: boolean
  showValidation?: boolean
}
type Emits = {
  (event: "remove" | "change", attribute: ProductModerationAttribute): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeSelectRow',
  props: {
    attribute: null,
    showDeleteButton: { type: Boolean },
    showValidation: { type: Boolean }
  },
  emits: ["remove", "change"],
  setup(__props: any, { emit }: { emit: ({
  (event: "remove" | "change", attribute: ProductModerationAttribute): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  attribute: ProductModerationAttribute
  showDeleteButton?: boolean
  showValidation?: boolean
};




const selectedValue = computed(() => {
  const codes = props.attribute.value.map((value) => value.code)
  return props.attribute.allow_multiple ? codes : codes[0]
})

const attributeValueSelectRef = ref<AttributeValueSelectHandle>()

const validateStatus = computed<string>(() => {
  if (!props.attribute.is_required) return "success"

  if (!props.showValidation) return "success"

  return hasAttributeValue(props.attribute) ? "success" : "error"
})
const fieldValidationMessage = computed<TranslateResult>(() =>
  validateStatus.value === "error" ? i18n.t("validations.required_field") : ""
)

const removeAttribute = () => {
  emit("remove", props.attribute)
}
const findValueOption = (item: string): ProductModerationAttributeValue => {
  return (
    attributeValueSelectRef.value?.selectOptions?.find(
      (option: ProductModerationAttributeValue) => option.code === item
    ) || props.attribute.value?.find((option) => option?.code === item)
  )
}
const onValueChanged = (value: string | string[]) => {
  const codes = Array.isArray(value) ? value : value ? [value] : []
  emit("change", {
    ...props.attribute,
    value: codes.map(findValueOption).filter(Boolean)
  })
}

const showCreateValueModal = ref(false)

const openCreateValueModal = () => {
  showCreateValueModal.value = true
}
const selectCreatedValue = (value: ProductModerationAttributeValue) => {
  if (props.attribute.value.some(({ code }) => code === value.code)) return

  emit("change", {
    ...props.attribute,
    value: props.attribute.allow_multiple ? [...props.attribute.value, value] : [value]
  })
}

return { __sfc: true,props, emit, selectedValue, attributeValueSelectRef, validateStatus, fieldValidationMessage, removeAttribute, findValueOption, onValueChanged, showCreateValueModal, openCreateValueModal, selectCreatedValue, InfiniteScrollSelect, fetchAttributeValues, getAttributeLabel, getAttributeValueLabel, CreateAttributeValueModal }
}

})